module.exports = __webpack_public_path__ + "static/media/udemyLogo.8bea66ff.webp";